import routes from './routes';
import { SetRoutes } from 'components';

const VacancyLanguagesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default VacancyLanguagesPages;
